import { Component, Input } from "@angular/core";

@Component({
  selector: "ui-no-data",
  templateUrl: "./ui-no-data.component.html",
  styleUrl: "./ui-no-data.component.scss",
  standalone: true
})
export class UiNoData {
  @Input() message: string = "Нет элементов";
}
